const OLD_CANDIDATE_COUNT = 400000;

export default OLD_CANDIDATE_COUNT;
